import { ButtonProps, ButtonSize, ButtonVariant } from "./Button.types";
import baseStyles from "./styles/Button.base.module.css";
import sizeStyles from "./styles/Button.sizes.module.css";
import variantStyles from "./styles/Button.variants.module.css";

const CONTAINER = "container";
const TEXT = "text";
const DISABLED = "disabled";

const getStyle = (
  base: string,
  size: ButtonSize,
  variant: ButtonVariant,
  disabled: boolean
) =>
  `${baseStyles.container} ${sizeStyles[`${base}_${size}`]} ${
    disabled
      ? variantStyles[`${base}_${variant}_${DISABLED}`]
      : variantStyles[`${base}_${variant}`]
  }`;

const Button = ({
  text,
  onClick,
  size = ButtonSize.MEDIUM,
  variant = ButtonVariant.PRIMARY,
  disabled = false,
  testID,
  type = "button",
  ariaLabel,
}: ButtonProps) => {
  const containerStyles = getStyle(CONTAINER, size, variant, disabled);
  const textStyles = getStyle(TEXT, size, variant, disabled);

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={containerStyles}
      data-testid={testID}
      type={type}
      aria-label={ariaLabel}
    >
      <span className={textStyles}>{text}</span>
    </button>
  );
};

export default Button;
